import cs from 'classnames';
import { useOutlet } from '@/context/OutletContext';

import './Mobile.scss';

export interface IMobileProps {
  children: React.ReactNode;
}

function InboxMobile({ children }: IMobileProps) {
  const { theme } = useOutlet();

  return (
    <div className={cs('mobile-container', theme)}>
      <div className={cs('mobile-header', theme)}>
        <div className={cs('ios-head-bar', theme)}></div>
      </div>
      <div className={cs('mobile-body', theme)}>
        {children}
      </div>
      <div className="mobile-footer"></div>
    </div>
  );
}

export default InboxMobile;
